import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataSharingService } from '../services/data-sharing.service';
import { WebSocketService } from '../services/web-socket.service';

declare var startRecording;
declare var leaveChannel;
declare var switchStream;
declare var stopLocalStream;
declare var SwitchDevice;
declare var muteAudio;
declare var unmuteAudio;
declare var getVideoDevice;
declare var getCameras;

declare var switchCameraOnMobile;
declare var switchVideoDevice;
declare var muteUnmuteAudio;
declare var setLogIntoDB;
declare var sendLogDataToServer;

@Component({
  selector: 'app-remote-user-screen',
  templateUrl: './remote-user-screen.component.html',
  styleUrls: ['./remote-user-screen.component.scss']
})
export class RemoteUserScreenComponent implements OnInit {

  invitationObj = {};
  /*****************Lat long**************/
  latitude: number = 0;
  longitude: number = 0;
  /**********************End lat long********/

  isFrontCameraEnabled = true;
  // selectedVideoSource = "";

  selStreamId: string = "";
  showConfirmationModal: boolean = false;

  recordingStarted: boolean = true;
  clientName: string = "";
  applicantName: string = "";

  isMute: boolean = false;
  isCameraSwitch: boolean = false;
  DevicesLog: any = {};
  deviceId = '';
  constructor(private activatedRoute: ActivatedRoute,
    private dataSharingSrvc: DataSharingService, private webSocketSrvc: WebSocketService) { }

  ngOnInit(): void {
    this.recordingStarted = true;
    this.getTheLatLongFromTheBrowser();
    this.getInvitationDetails();
    // this.DevicesLog = getVideoDevice();
  }
  ngAfterContentInit(): void {
    //Called after ngOnInit when the component's or directive's content has been initialized.
    //Add 'implements AfterContentInit' to the class.
    setTimeout(() => getCameras(), 900)
  }

  switchCamera() {
    console.log();
    switchCameraOnMobile(this.isFrontCameraEnabled)
    this.isFrontCameraEnabled = !this.isFrontCameraEnabled;
    
  }


  leaveChannelConfirmation() {
    this.showConfirmationModal = true;
  }


  hideLocalVideo() {
    document.getElementById("videoundefined").style.display = 'none';
  }


  closeErrorModal() {
    this.recordingStarted = false;
    document.getElementById("errormsgModal").style.display = "none";
    // this.hideLocalVideo();
  }

  closeMeeting() {
    this.recordingStarted = false;
    this.showConfirmationModal = false;
    leaveChannel();
    stopLocalStream();
    this.hideLocalVideo();
  }

  shareLocation() {

    try {
      this.dataSharingSrvc.postMethod("/saveresponderlocation", { "latitude": this.latitude, "longitude": this.longitude })
        .subscribe(
          succ => {
            console.log("share location : ", succ);
          },
          err => {
            console.error("service failed : ", err);
          }
        )
    } catch (err) {
      console.error(err);
    }

  }

  changeStream(evt) {
    switchStream(this.selStreamId);
  }

  shareLocationByWebsocket(currPos) {
    this.webSocketSrvc.sendLatLongToServerUntilVideoCallerReceiveIt(currPos);
  }

  getTheLatLongFromTheBrowser = () => {
    navigator.geolocation.getCurrentPosition((currPos) => {
      // console.log(currPos);
      this.latitude = currPos['coords']['latitude'];
      this.longitude = currPos['coords']['longitude'];
      // let posStr = this.latitude + "," + this.longitude+","+ this.activatedRoute.snapshot.params['id'];
      let posStr = this.latitude + "," + this.longitude+","+ this.dataSharingSrvc["autoId"];
      this.shareLocationByWebsocket(posStr);
    },
      (err) => {
        console.error('Get Geolocation Error :', err['message']);
      }, { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 });
  }


  getInvitationDetails() {
    // this.activatedRoute.queryParams.subscribe((params:any)=>{
    //   console.log('params',params);
      
    //   this.dataSharingSrvc["autoId"] = params['autoid'];
    // })
    // this.dataSharingSrvc["autoId"] = this.activatedRoute.snapshot.params['id'];
    // this.dataSharingSrvc.getMethod("getChannelDetails/" + this.activatedRoute.snapshot.params['id'], {})
    this.dataSharingSrvc.getMethod("getChannelDetails/" + this.dataSharingSrvc["autoId"], {})
      .subscribe(
        succ => {
          this.invitationObj = {};
          if (succ['errorCode'] == 0) {
            this.invitationObj = JSON.parse(JSON.stringify(succ['data']));
            this.clientName = this.invitationObj['clientName'];
            this.applicantName = this.invitationObj['applicantName'];
            // this.invitationObj['channel'] = "testvideo";
            console.log("this.invitationObj['uid']", this.invitationObj['uid']);
            // this.pushDevices();
            if(this.invitationObj['isvcallogstartflag'] == 'Y'){
              setLogIntoDB(true);
            }else{
              setLogIntoDB(false);
            }
            let uidNo = +(this.invitationObj['uid'] + '').substr(0, 6);
            setTimeout(() => {
              startRecording(this.invitationObj['appId'], this.invitationObj['token']['remoteUserToken'], this.invitationObj['channel'], uidNo, this.invitationObj['resObj']['caseId']);
            }, 2000);
          }
          else {
            console.error(succ);
          }
        },
        err => {
          console.error(err);
        }
      )
  }


  pushDevices() {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      let videoSourcesSelect = document.getElementById("video-source");
      let audioSourcesSelect = document.getElementById("audio-source");

      // Iterate over all the list of devices (InputDeviceInfo and MediaDeviceInfo)
      devices.forEach((device) => {
        let option = new Option();
        option.value = device.deviceId;

        // According to the type of media device
        switch (device.kind) {
          // Append device to list of Cameras
          case "videoinput":
            option.text = device.label || `Camera ${videoSourcesSelect['length'] + 1}`;
            videoSourcesSelect.appendChild(option);
            break;
          // Append device to list of Microphone
          case "audioinput":
            option.text = device.label || `Microphone ${videoSourcesSelect['length'] + 1}`;
            audioSourcesSelect.appendChild(option);
            break;
        }

        console.log(device);
      });
    }).catch(function (e) {
      console.log(e.name + ": " + e.message);
    });
  }


  muteTheCallAudio() {
    // if(muteAudio())
    this.isMute = muteUnmuteAudio(false);
    // this.isMute = true;
  }
  unmuteTheCallAudio() {
    this.isMute = muteUnmuteAudio(true);
    // this.isMute = false;
  }
  switchDevice() {
    this.isCameraSwitch = !this.isCameraSwitch;
    this.DevicesLog = SwitchDevice(this.isCameraSwitch);
  }
  switchDeviceWithId(id) {
    switchVideoDevice(this.deviceId)
  }
}
